const regex = /(?:\{AD_ACCOUNT_ID\})/g;
const customAudiencesErrors = [{
    code: 200,
    subcode: 1870050,
    title: 'Personal ad account found',
    message: 'Your ad account needs to be part of <strong>Facebook Business Manager</strong> to create your custom audience.\n\nPlease convert your ad account to <strong>Facebook Business Manager</strong> and try again.',
    linkWording: 'Learn more about converting your ad account',
    link: 'https://lonewolf.my.site.com/s/liondesk-resources/ad-portal',
  },
  {
    code: 200,
    subcode: 1870034,
    title: 'Terms not accepted',
    singleMessage: 'Please <strong><a href="https://business.facebook.com/ads/manage/customaudiences/tos/?act={AD_ACCOUNT_ID}" target="_blank">click here</a></strong> to accept Facebook\'s custom audience terms of service before continuing.',
  },
];

const getCustomAudiencesError = (codeNumber, isSubcode, adAccountId) => {
  const errorDetails = isSubcode ?
    customAudiencesErrors.find(e => e.subcode == codeNumber) :
    customAudiencesErrors.find(e => e.code == codeNumber);
  if(errorDetails.singleMessage) {
    errorDetails.singleMessage = errorDetails.singleMessage.replace(regex, adAccountId);
  }
  return errorDetails ? errorDetails : {}
};

export default getCustomAudiencesError;
